module.exports = __webpack_public_path__ + "static/media/Burndownchart.515dcb6c.svg";